<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header mb-4"
    >
      <div class="md-layout">
        <div
          class="md-layout-item md-medium-size-100 md-size-100 truncated_header2"
        >
          <div class="md-layout md-alignment-center">
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60 p-0 report-header"
            >
              <h4>{{ this.headerData.title }}</h4>
              <ul>
                <li>
                  <h6>
                    <i class="md-icon md-icon-dark-blue">business_center</i
                    >Industry:
                  </h6>
                  <p>
                    [{{ parseFloat(this.headerData.bznaics) }}]
                    {{ this.headerData.industry }}
                  </p>
                </li>
                <li>
                  <h6><i class="md-icon">apartment</i>Sector:</h6>
                  <p>{{ this.headerData.sector }}</p>
                </li>
                <li>
                  <h6><i class="md-icon">place</i>Market Area:</h6>
                  <p>{{ this.headerData.area }}</p>
                </li>
                <li>
                  <h6><i class="md-icon">equalizer</i>Sales Class:</h6>
                  <p>{{ this.headerData.sales_class }}</p>
                </li>
              </ul>
            </div>
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-50 md-size-40 button-box"
            >
              <md-button
                class="md-info access-button pdf_btn"
                @click="feedback"
              >
                <md-icon>comment</md-icon>Product Feedback
              </md-button>

              <md-button
                v-if="report && Object.keys(report).length && !pdfLoading"
                class="md-info access-button pdf_btn"
                @click="downloadPDFData"
              >
                <md-icon class="ml-5">picture_as_pdf</md-icon>Download PDF
              </md-button>
              <md-button
                v-if="report && !Object.keys(report).length"
                class="md-info access-button pdf_btn"
              >
                <template>
                  <md-icon class="ml-5">picture_as_pdf</md-icon>Loading...
                </template>
              </md-button>
              <md-button
                v-if="pdfLoading"
                class="md-info access-button pdf_btn"
              >
                <template>
                  <md-icon class="ml-5">picture_as_pdf</md-icon>Downloading...
                </template>
              </md-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal
      v-if="feedbackModal"
      @close="feedbackModal = false"
      class="feedback_modal"
    >
      <template slot="body">
        <button type="button" class="close_btn" @click="feedbackModal = false">
          <md-icon>clear</md-icon>
        </button>
        <h3 class="modal-title">Have feedback on this product?</h3>
        <p>
          Enter the details below to send your feedback to our Product Team.
        </p>
        <form action class="form_grp">
          <div class="field_wpr">
            <label>Leave A Feedback Note</label>
            <textarea
              v-model="textFeedback"
              placeholder="Type a message"
            ></textarea>
            <md-field>
              <md-select v-model="category" name="category">
                <md-option
                  v-for="(option, key) in optionsCategory"
                  :key="key"
                  :label="option"
                  :value="key"
                  >{{ option }}
                </md-option>
              </md-select>
            </md-field>
            <md-button @click="sendFeedback" class="md-info md-round mt-4"
              >Send Feedback</md-button
            >
          </div>
        </form>
      </template>
    </modal>

    <div
      v-if="headerData"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100  p-0"
    >
      <CREPORTPDF
        ref="crPDF"
        :headerData="headerData"
        :user="user"
        :report="report"
      />
    </div>
  </div>
</template>
<script>
import { Collapse, Modal } from "@/components";
//import Avatar from 'vue-avatar';

import CREPORTPDF from "./_partials/CRPDF.vue";
import axios from "axios";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    Modal,
    CREPORTPDF,
  },
  data() {
    return {
      optionsCategory: {
        0: "Select a Category",
        1: "1 - Report an Error",
        2: "2 - Suggest an Improvement",
        3: "3 - Request a Correction",
        4: "4 - Request an Update",
      },

      category: 0,
      loading: false,
      feedbackModal: false,
      textFeedback: "",
    };
  },
  props: ["headerData"],
  mounted() {
    this.$store.commit("user/SET_PDF_LOADING", false);
  },

  methods: {
    ...mapActions({
      registerProductExport: "tracking/registerProductExport",
    }),
    downloadPDFData() {
      this.registerProductExport({
        userId: this.auth_user?.user?.userID,
        productId: this.$route.params.id,
        exportType: "PDF",
      });
      this.$refs.crPDF.generateReport();
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          if (!this.$store.getters["user/pdfMustBeDownloaded"])
            window.open(pdf.output("bloburl"), "_blank");
        });
    },
    feedback() {
      this.feedbackModal = true;
    },
    sendFeedback() {
      let parameters = {};

      parameters["name"] = "Company Report";
      parameters["Industry"] = this.headerData;

      parameters = JSON.stringify(parameters);

      if (this.category) {
        let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
        );
        axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/user/feedback/submit",
            {},
            {
              params: {
                session_id: currentSession,
                feedback: this.textFeedback,
                url: `${window.location.href}`,
                category: this.category,
                parameters: parameters,
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }

            if (res.data.success)
              this.$store.dispatch("alerts/success", "Data saved.");
            else
              this.$store.dispatch(
                "alerts/error",
                "An error occured. please try again"
              );

            this.feedbackModal = false;
            this.textFeedback = null;
            this.category = null;

            this.checkBoxOption1 = false;
            this.checkBoxOption2 = false;
            this.checkBoxOption3 = false;
            this.checkBoxOption4 = false;
          });
      } else {
        this.$store.commit("SET_ERROR_BIT", true);
        this.$store.commit(
          "SET_ERROR_INFO",
          "<br>" +
            "Server responded with error = True <br> errorCode: " +
            "category_not_set" +
            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
        );
      }
    },
    switchView: function(type) {
      this.view = type;
    },
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      data: (state) => state.user.report.data,
      profile: (state) => state.user.profile,
      report: (state) => state.user.company_report,
      pdfLoading: (state) => state.user.pdfLoading,
    }),
    user() {
      return this.$store.state.user.user;
    },
    profileId() {
      return this.$route.params.id;
    },
    companyReportSummary() {
      return this.$store.getters["user/companyReport"];
    },
    companyReportReleaseDisplay() {
      return this.$store.getters.companyReportReleaseDisplay;
    },
    swotSales() {
      return this.companyReportSummary && this.companyReportSummary.score1
        ? Object.keys(this.companyReportSummary.scores1).map((key) => {
            return {
              title: key,
              score: this.companyReportSummary.scores1[key],
            };
          })
        : null;
    },
    inputStructure() {
      return this.companyReportSummary
        ? Object.keys(this.companyReportSummary?.input_structure).map((key) => {
            return {
              title: key,
              info: this.companyReportSummary?.input_structure[key]["value"],
            };
          })
        : null;
    },
    swotOperatingIndicators() {
      return this.companyReportSummary && this.companyReportSummary.score2
        ? Object.keys(this.companyReportSummary?.scores2).map((key) => {
            return {
              title: key,
              score: this.companyReportSummary?.scores2[key],
            };
          })
        : null;
    },
    location() {
      return this.companyReportSummary && this.companyReportSummary.score2
        ? [
            {
              CONAME: this.companyReportSummary?.input_structure["Company Name"]
                .value,
              lat: this.companyReportSummary.mapData?.lat,
              lng: this.companyReportSummary.mapData?.lon,
            },
          ]
        : null;
    },
    mapCenter() {
      return this.companyReportSummary && this.companyReportSummary.score2
        ? {
            lat: this.companyReportSummary.mapData?.lat,
            lon: this.companyReportSummary.mapData?.lon,
          }
        : null;
    },
    pdfDownloadSetting() {
      return this.user &&
        this.user.preferences &&
        this.user.preferences.defaultPDFDownload
        ? this.user.preferences.defaultPDFDownload
        : "_blank";
    },
  },
  watch: {
    report() {
      //alert('test')
    },
  },
};
</script>
<style>
.other-info-developed-by {
  height: 30% !important;
}
.div-developed-for-address {
  top: -20px !important;
  position: relative !important;
}
.div-developed-for {
  top: -40px !important;
  position: relative !important;
}
.ul-developed-for {
  border: none !important;
}
</style>
